module.exports = __webpack_public_path__ + "697574b47bcfdd2c45e3e63c7380dd67.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Semibold-webfont.woff
// module id = 1151
// module chunks = 0